import { InjectionToken, Provider, Type } from '@angular/core';
import { ChipCellComponent } from './renderers/chip-cell/chip-cell.component';
import { DateCellComponent } from './renderers/date-cell/date-cell.component';
import { IconListCellComponent } from './renderers/icon-list-cell/icon-list-cell.component';
import { MappedTextCellComponent } from './renderers/mapped-text-cell/mapped-text-cell.component';
import { TemperatureCellComponent } from './renderers/temperature-cell/temperature-cell.component';
import { TextCellComponent } from './renderers/text-cell/text-cell.component';

export type TableCellRenderers = Record<string, Type<unknown>>;

export const DEFAULT_TABLE_CELL_RENDERERS: TableCellRenderers = {
    'plain-text': TextCellComponent,
    'icon': IconListCellComponent,
    'chip': ChipCellComponent,
    'temperature-icon': TemperatureCellComponent,
    'mapped-to-text': MappedTextCellComponent,
    'date-only': DateCellComponent
};

export const TABLE_CELL_RENDERERS = new InjectionToken<TableCellRenderers>('TABLE_CELL_RENDERERS', {
    factory: () => DEFAULT_TABLE_CELL_RENDERERS
});

export const provideTableCellRenderers = (renderers: TableCellRenderers): Provider => ({
    provide: TABLE_CELL_RENDERERS,
    useValue: { ...DEFAULT_TABLE_CELL_RENDERERS, ...renderers }
});
